module.exports = __webpack_public_path__ + "img/symbol_3.0b5fbdab.png";